import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import useWindowWidth from '../../hooks/useWindowWidth';
import './Dashboard.css';

ChartJS.register(ArcElement, Tooltip, Legend);

const COLORS_BG = [
    'rgba(255, 159, 64, 0.7)',
    'rgba(75, 192, 192, 0.7)',
    'rgba(153, 102, 255, 0.7)',
    'rgba(255, 99, 132, 0.7)',
    'rgba(54, 162, 235, 0.7)',
];

const COLORS_BORDER = [
    'rgba(255, 159, 64, 1)',
    'rgba(75, 192, 192, 1)',
    'rgba(153, 102, 255, 1)',
    'rgba(255, 99, 132, 1)',
    'rgba(54, 162, 235, 1)',
];

function ExpensesByCardChart({ data, onCardClick }) {
    const width = useWindowWidth();
    const isMobile = width < 768;

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: isMobile ? 'bottom' : 'right',
                labels: {
                    boxWidth: isMobile ? 12 : 16,
                    padding: isMobile ? 8 : 12,
                    font: { size: isMobile ? 11 : 12 },
                },
            },
            title: {
                display: !isMobile,
                text: 'Despesas por Cartão',
            },
        },
        onClick: (event, elements) => {
            if (elements.length > 0) {
                const elementIndex = elements[0].index;
                const card = data[elementIndex];
                onCardClick(card);
            }
        },
    };

    const chartData = {
        labels: data?.map(d => d.card_name) || [],
        datasets: [
            {
                label: 'Despesas',
                data: data?.map(d => d.total) || [],
                backgroundColor: COLORS_BG,
                borderColor: COLORS_BORDER,
                borderWidth: 1,
            },
        ],
    };

    if (isMobile) {
        return (
            <div className="dash-chart-section-m">
                <p className="dash-chart-title-m">Despesas por Cartão</p>
                <div style={{ height: '280px' }}>
                    {data ? <Doughnut options={options} data={chartData} /> : <p style={{ fontSize: '0.8rem', color: '#94a3b8' }}>Carregando...</p>}
                </div>
            </div>
        );
    }

    return (
        <div className="card shadow-sm h-100">
            <div className="card-body" style={{ height: '400px' }}>
                {data ? <Doughnut options={options} data={chartData} /> : <p>Carregando dados do gráfico...</p>}
            </div>
        </div>
    );
}

export default ExpensesByCardChart;
